






import Vue from 'vue'
import { portalState } from '@/state'

export default Vue.extend({
  name: 'Missing',
  computed: {
    nightMode () { return this.$vuetify.theme.dark },
    endpoints () {
      const url = window.location.origin
      if (url.includes('acc')) {
        return {
          api: 'https://dashboardacc.tracefy.io',
          microFrontend: 'https://trackacc-portal.tracefy.com'
        }
      } else {
        return {
          api: 'https://dashboard.tracefy.net',
          microFrontend: 'https://track-portal.tracefy.com'
        }
      }
    }
  },
  data () {
    return {
      microMessage: null
    }
  },
  methods: {
    async sendInfo () {
      const token = await this.$auth.getTokenSilently()
      const { nightMode } = this
      const superAdmin = portalState.user.role === 'Super Admin'
      this.$refs.missingIFrame.contentWindow.postMessage({ token, superAdmin, nightMode }, this.endpoints.microFrontend)
    }
  },
  async mounted () {
    window.onmessage = (e: MessageEvent) => { this.microMessage = e.data }
  },
  watch: {
    microMessage (value) {
      if (value.type === 'requestingPortalInfo') {
        this.sendInfo()
      }
    },
    nightMode () {
      this.sendInfo()
    }
  }
})
